import { AxiosResponse } from 'axios';
import axiosInstance from 'services/axios/axios';
import { then } from 'services/axios/_utility';

/**
 * Fetch Departments
 * @param {string} queryParam user input
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of departments
 */
export const fetchStateList = async dispatch => {
	return await axiosInstance
		.get('api/Applications/EpicLink/States')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

export const fetchJobCategoryData = async (queryParam, dispatch) => {
	return await axiosInstance
		.get('api/Applications/EpicLink/JobCategories', {
			params: {
				value: queryParam,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

export const fetchProviderJobCategories = async dispatch => {
	return await axiosInstance
		.get('api/Applications/EpicLink/JobCategories/ProviderJobCategories')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

export const fetchNpiDataByTN = async (value, trackingNumber) => {
	return await axiosInstance
		.get(
			`api/Applications/EpicLink/NPIValidation/${value}/${trackingNumber}`,
		)
		.then(response => response.data)
		.catch(ex => {
			throw ex;
		});
};

export const fetchNpiData = async (value, lastName, firstName) => {
	return await axiosInstance
		.get(
			`api/Applications/EpicLink/NPIValidation/${value}/${lastName}/${firstName}`,
		)
		.then(response => response.data)
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch Location options
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of locations
 */
export const fetchLocationData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/EpicLink/Locations')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};
